import logo from './logo.svg';
import './App.css';
import Particles from 'react-particles-js';
import particlesConfig from './config/configParticles';
import Header from './Components/Header/Header';
import { Card, Navbar } from 'react-bootstrap';
import headimage from '../src/img/Untitled-2.png'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link as Link
} from "react-router-dom";
import About from './Components/About/About';
import Blogs from './Components/Blogs/Blogs';
import Contact from './Components/Contact/Contact';
import Card1 from './Components/Card/Card1';

function App() {
  return (
    <Router>
      <div className="App" style={{ position: 'relative', overflow: "hidden" }}>
          <Switch>
          </Switch>
            <Header></Header>
            <About></About>
            <Card1></Card1>
            <Blogs></Blogs>
            <Contact></Contact>
      </div>
   </Router>
  );
}

export default App;
